import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {CustomDropdownComponent} from './custom-dropdown.component';
import {DropdownTriggerForDirective} from 'src/app/shared/components/custom-dropdown/dropdown-trogger-for.directive';



@NgModule({
    declarations: [
        CustomDropdownComponent,
        DropdownTriggerForDirective,
    ],
    imports: [
        CommonModule
    ],
    exports: [
        CustomDropdownComponent,
        DropdownTriggerForDirective,
    ]
})
export class CustomDropdownModule { }
